import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { formatCountdown, getTimeRemaining } from '../../utils/helpers';

const CountdownTimer = ({ expiresAt, onExpire }) => {
    const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining(expiresAt));

    useEffect(() => {
        const interval = setInterval(() => {
            const remaining = getTimeRemaining(expiresAt);
            setTimeRemaining(remaining);

            if (remaining <= 0) {
                clearInterval(interval);
                if (onExpire) {
                    onExpire();
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [expiresAt, onExpire]);

    const isWarning = timeRemaining < 60000; // Less than 1 minute
    const isExpired = timeRemaining <= 0;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    fontFamily: 'monospace',
                    color: isExpired ? 'error.main' : isWarning ? 'warning.main' : 'text.primary',
                    fontWeight: 600,
                }}
            >
                {isExpired ? '00:00' : formatCountdown(timeRemaining)}
            </Typography>
            {isExpired && (
                <Typography variant="body2" color="error">
                    (Đã hết hạn)
                </Typography>
            )}
        </Box>
    );
};

export default CountdownTimer;
